import styles from "./browser-warning-message.less";

type BrowserWarningMessageProps = {
    message: string;
};

export const BrowserWarningMessage = (props: BrowserWarningMessageProps) => {
    const { message } = props;
    
    return (
        <div className={styles.browserWarningMessage}>
            <span>{message}</span>
        </div>
    );
};